import { Trans } from "react-i18next";

import type { NotificationContentProps } from "../../types";

export default function DeadlineApproaching({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.ideaDeadlineApproaching"
      values={{ idea: ownerIdea?.name || "Deleted" }}
    />
  );
}
